export const getWebkitFontSmoothingFromComputedStyle = (
  computedStyle: CSSStyleDeclaration,
) => {
  return 'webkitFontSmoothing' in computedStyle &&
    typeof computedStyle.webkitFontSmoothing === 'string'
    ? computedStyle.webkitFontSmoothing
    : null;
};
